import React from "react";

export default function MSAccess_Sum() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Sum</h1>
      <p>This is the MSAccess_Sum component generated from the SQL JSON.</p>
    </div>
  );
}
